export default __webpack_public_path__ + "static/graph-stats-4a377b7bcd992949be6e3d37c034747d.svg";